<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->
<centered-layout *ngIf="layout === 'centered'"></centered-layout>

<!-- Enterprise -->
<enterprise-layout *ngIf="layout === 'enterprise'"></enterprise-layout>

<!-- Material -->
<material-layout *ngIf="layout === 'material'"></material-layout>

<!-- Modern -->
<modern-layout *ngIf="layout === 'modern'"></modern-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classic -->
<classic-layout *ngIf="layout === 'classic'"></classic-layout>

<!-- Classy -->
<classy-layout *ngIf="layout === 'classy'"></classy-layout>

<!-- Compact -->
<compact-layout *ngIf="layout === 'compact'"></compact-layout>

<!-- Dense -->
<dense-layout *ngIf="layout === 'dense'"></dense-layout>

<!-- Futuristic -->
<futuristic-layout *ngIf="layout === 'futuristic'"></futuristic-layout>

<!-- Thin -->
<thin-layout *ngIf="layout === 'thin'"></thin-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Settings drawer - Remove this to remove the drawer and its button -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- <div
    class="
        fixed
        flex
        items-center
        justify-center
        right-0
        w-10
        h-10
        shadow-lg
        rounded-l-lg
        z-999
        cursor-pointer
        bg-red-600 bg-opacity-90
        print:hidden
    "
    style="top: 275px"
    (click)="settingsDrawer.toggle()"
>
    <mat-icon
        class="icon-size-5 text-white animate-spin-slow"
        [svgIcon]="'heroicons_solid:cog'"
    ></mat-icon>
</div> -->

<fuse-drawer class="w-100 min-w-100" fixed transparentOverlay [mode]="'over'" [name]="'settingsDrawer'"
  [position]="'right'" #settingsDrawer>
  <div class="flex flex-col w-full overflow-auto bg-card">
    <div class="
                flex flex-row
                items-center
                px-6
                h-20
                min-h-20
                text-white
                bg-primary
            ">
      <mat-icon class="icon-size-7 text-current" [svgIcon]="'heroicons_solid:cog'"></mat-icon>
      <div class="ml-3 text-2xl font-semibold tracking-tight">
        Settings
      </div>
    </div>

    <div class="flex flex-col p-6">
      <!-- Admin -->
      <div class="text-md font-semibold text-secondary">ADMIN</div>
      <div class="grid grid-cols-2 gap-3 justify-items-start mt-6">
        <!-- Manage Forms -->
        <div class="
                        flex
                        items-center
                        py-3
                        pl-5
                        pr-6
                        rounded-full
                        cursor-pointer
                        ring-inset ring-primary
                        bg-hover
                    " [class.ring-2]="activeAdminMenu === 'manage-forms'"
          (click)="redirectSettings('/forms/list', 'manage-forms')">
          <div class="flex items-center rounded-full overflow-hidden">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:view-list'"></mat-icon>
          </div>
          <div class="
                            flex
                            items-center
                            ml-2
                            font-medium
                            leading-5
                            whitespace-nowrap
                            overflow-ellipsis overflow-hidden
                        ">
            Manage Forms
          </div>
        </div>

        <!-- Manage Delegation -->
        <div class="
                flex
                items-center
                py-3
                pl-2 pr-2
                rounded-full
                cursor-pointer
                ring-inset ring-primary
                bg-hover
            " [class.ring-2]="activeAdminMenu === 'manage-delegation'"
          (click)="redirectSettings('/delegations/list', 'manage-delegation')">
          <div class="flex items-center rounded-full overflow-hidden">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:database'"></mat-icon>
          </div>
          <div class="
                    flex
                    items-center
                    ml-2
                    font-medium
                    leading-5
                    whitespace-nowrap
                    overflow-ellipsis overflow-hidden
                ">
            Manage Delegations
          </div>
        </div>

        <!-- Manage Users -->
        <div class="
                        flex
                        items-center
                        py-3
                        pl-5
                        pr-6
                        rounded-full
                        cursor-pointer
                        ring-inset ring-primary
                        bg-hover
                    " [class.ring-2]="activeAdminMenu === 'manage-users'"
          (click)="redirectSettings('/users/list', 'manage-users')">
          <div class="flex items-center rounded-full overflow-hidden">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:user-add'"></mat-icon>
          </div>
          <div class="
                            flex
                            items-center
                            ml-2
                            font-medium
                            leading-5
                            whitespace-nowrap
                            overflow-ellipsis overflow-hidden
                        ">
            Manage Users
          </div>
        </div>

        <!-- Manage Lookups -->
        <div class="
                        flex
                        items-center
                        py-3
                        pl-5
                        pr-6
                        rounded-full
                        cursor-pointer
                        ring-inset ring-primary
                        bg-hover
                    " [class.ring-2]="activeAdminMenu === 'manage-lookups'"
          (click)="redirectSettings('/lookups/manage', 'manage-lookups')">
          <div class="flex items-center rounded-full overflow-hidden">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:database'"></mat-icon>
          </div>
          <div class="
                            flex
                            items-center
                            ml-2
                            font-medium
                            leading-5
                            whitespace-nowrap
                            overflow-ellipsis overflow-hidden
                        ">
            Manage Lookups
          </div>
        </div>

 <!-- Cache Reset -->

        <div class="
        flex
        items-center
        py-3
        pl-5
        pr-6
        rounded-full
        cursor-pointer
        ring-inset ring-primary
        bg-hover
    "[class.ring-2]="activeAdminMenu === 'cache-clear'"
  (click)="cacheClear()">
  <div class="flex items-center rounded-full overflow-hidden">
  <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:refresh'"></mat-icon>
  </div>
  <div class="
            flex
            items-center
            ml-2
            font-medium
            leading-5
            whitespace-nowrap
            overflow-ellipsis overflow-hidden
        ">
  Reset Cache
  </div>
  </div>


      </div>
     


      <hr class="my-8" />


      

      <!-- Theme -->
      <div class="text-md font-semibold text-secondary">THEME</div>
      <div class="grid grid-cols-3 gap-3 mt-6">
        <ng-container *ngFor="let theme of themes">
          <div class="
                            flex
                            items-center
                            px-4
                            py-3
                            rounded-full
                            cursor-pointer
                            ring-inset ring-primary
                            bg-hover
                        " [class.ring-2]="config.theme === theme[0]" (click)="setTheme(theme[0])">
            <div class="w-4 h-4 rounded-full" [style.background-color]="theme[1].primary"></div>
            <div class="ml-2.5 font-medium leading-5" [class.text-secondary]="config.theme !== theme[0]">
              {{ theme[0] | titlecase }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</fuse-drawer>